import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as uploadActionCreators from '../../actions/uploads';

function mapStateToProps(state) {
    return {uploadState : state.uploads};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(uploadActionCreators, dispatch);
}

class Uploads extends React.Component {

    render() {
        return React.cloneElement(this.props.children, this.props);
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Uploads);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Uploads.jsx
 **/